import siteIds from '../../constants/siteIds';

export default function (subtotal, siteId, totalLeft) {
	let exceededCapacity = false;

	if (siteId !== siteIds.giftCardConnection && subtotal >= (totalLeft || 160)) {
		exceededCapacity = true;
	} else if (siteId === siteIds.giftCardConnection && subtotal >= (totalLeft || 60)) {
		exceededCapacity = true;
	}

	return exceededCapacity;
}
